var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chosenfamilies",staticClass:"section pride-chosen-families-container"},[_c('div',{staticClass:"pride-inner"},[_c('h3',{domProps:{"innerHTML":_vm._s(_vm.chosenFamilies.COPY)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dccaa8c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pride/PrideChosenFamilies.vue
// module id = null
// module chunks = 